import { ShareBetData } from '@core/Areas/ShareBet/types'
import { shouldAllowShareInBetLoop } from '../../helpers/shouldAllowShareInBetLoop'
import { useVenueModeRacingEvents } from '@core/Areas/VenueMode/Components/Racing/Data/api'

export const useShouldAllowShareInBetLoop = (data: ShareBetData) => {
  const { data: venueModeEvents } = useVenueModeRacingEvents()

  return shouldAllowShareInBetLoop(data, venueModeEvents)
}
